import { useNavigate } from 'react-router-dom';
import { describeWeights } from '@crossmatch/shared';
import { Button } from '../components/Button.js';
import { Card } from '../components/Card.js';
import { Collapsible } from '../components/Collapsible.js';
import { SiteFooter } from '../components/SiteFooter.js';

/** 落地页的价值点：文案取自 01_商业计划书/一页纸商业计划.md 的「问题/方案/差异/合规」，不编造成果数据。 */
const VALUE_POINTS: { icon: string; title: string; body: string }[] = [
  {
    icon: '🧭',
    title: '结构化技能画像',
    body: '7 类技能 + 每周可投入时间 + 可协作时段，3 分钟填完。',
  },
  {
    icon: '🎯',
    title: '互补度匹配，理由可解释',
    body: `按「项目缺什么」优先排序：${describeWeights()}；每条推荐都写清理由。`,
  },
  {
    icon: '📋',
    title: '一键成队与阶段待办',
    body: '成队自动生成四阶段待办，进度与负责人看得见。',
  },
  {
    icon: '🛡',
    title: '跨校组队与数据最小化',
    body: '松江七校跨校匹配；只收学校/专业/技能/时间，可导出可删除。',
  },
];

/** 未登录时的产品落地页（已登录由 App.tsx 直接送进应用）。 */
export function LandingPage() {
  const navigate = useNavigate();
  return (
    <div className="auth-shell">
      <div className="landing-wrap">
        <section className="landing-hero">
          <span className="landing-kicker">松江七校 · 跨校 AI 组队引擎</span>
          <h1 className="landing-title">
            把「凑不齐一队人」
            <br />
            变成 <span className="grad">更快找到互补队友</span>
          </h1>
          <p className="landing-sub">
            面向高校赛事的组队基础设施：3 分钟技能画像、可解释 AI 互补匹配、组队后自动生成备赛待办。
            不做社交，只做「组队」这一段。
          </p>
          <div className="landing-cta">
            <Button variant="primary" onClick={() => navigate('/register')}>
              立即注册（30 秒）
            </Button>
            <Button variant="secondary" onClick={() => navigate('/login')}>
              已有账号，登录
            </Button>
          </div>
          <div className="hero-metrics">
            <div className="hero-metric">
              <div className="hero-metric-num">7 校</div>
              <div className="hero-metric-label">松江跨校组队</div>
            </div>
            <div className="hero-metric">
              <div className="hero-metric-num">4 维</div>
              <div className="hero-metric-label">互补度可解释</div>
            </div>
            <div className="hero-metric">
              <div className="hero-metric-num">3 分钟</div>
              <div className="hero-metric-label">填完技能画像</div>
            </div>
            <div className="hero-metric">
              <div className="hero-metric-num">0</div>
              <div className="hero-metric-label">收学号 / 手机号</div>
            </div>
          </div>
          <div className="landing-points">
            <span className="landing-point">四维度匹配 · 理由可解释</span>
            <span className="landing-point">AI 队友「小叉」</span>
            <span className="landing-point">组队 → 备赛闭环</span>
            <span className="landing-point">数据可导出可删除</span>
          </div>
        </section>

        <div className="grid-2">
          {VALUE_POINTS.map((point) => (
            <Card key={point.title} title={`${point.icon} ${point.title}`}>
              <p className="field-hint">{point.body}</p>
            </Card>
          ))}
        </div>

        <Collapsible
          title="评委 / 访客：4 步看完整个产品"
          hint="点开看体验路径（含演示数据一键载入）"
        >
          <ol className="landing-steps">
            <li>注册并登录（只填邮箱、昵称、学校、密码）。</li>
            <li>「设置与合规 → 演示模式」点「载入演示数据」，会载入一批带 demo- 前缀的候选人。</li>
            <li>「找队友 → 开始匹配」选技能需求与每周投入，查看互补度排序与推荐理由。</li>
            <li>讲完回「设置与合规」点「清除演示数据」，只删演示数据，不动自己录入的内容。</li>
          </ol>
        </Collapsible>

        <p className="muted small">
          当前为可演示原型：匹配由确定性互补度算法给出（可解释、可复核），尚无真实用户数据，文中规模与商业数字均为估算。
        </p>
      </div>
      <SiteFooter />
    </div>
  );
}